export const roleRequest = [{
  id: true,
  version: true,
  archivedAt: true,
  identifier: true,
  level: true,
  permissions: {id: true}
}];
